(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["everyblind-samples-drawer"] && !Shopify.designMode) return;
  try {
    const everyBlindNormaliseImageName = (url) => {
    const filename = decodeURIComponent((url || '').split('?')[0].split('/').pop() || '');
    return filename
      .replace(/\.[a-z0-9]+$/i, '')
      .replace(/_(pico|icon|thumb|small|compact|medium|large|grande|master|\d+x\d+)$/i, '')
      .toLowerCase();
  };

  const everyBlindFallbackSampleName = (url) => {
    const filename = decodeURIComponent((url || '').split('?')[0].split('/').pop() || 'Sample');
    const cleaned = filename
      .replace(/\.[a-z0-9]+$/i, '')
      .replace(/_(pico|icon|thumb|small|compact|medium|large|grande|master)$/i, '')
      .replace(/_[0-9a-f]{8}(?:-[0-9a-f]{4}){3}-[0-9a-f]{12}$/i, '')
      .replace(/[-_]\d+x\d+/gi, '')
      .replace(/[-_]\d+$/g, '')
      .replace(/[-_]+/g, ' ')
      .replace(/([a-z])([A-Z])/g, '$1 $2')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
    return cleaned.replace(/\b\w/g, (letter) => letter.toUpperCase()) || 'Sample';
  };

  const everyBlindReadSampleNames = () => {
    try {
      return JSON.parse(window.localStorage.getItem('everyblind_sample_names') || '{}');
    } catch (error) {
      return {};
    }
  };

  const everyBlindWriteSampleNames = (sampleNames) => {
    try {
      window.localStorage.setItem('everyblind_sample_names', JSON.stringify(sampleNames));
    } catch (error) {
      return;
    }
  };

  const everyBlindGetProductName = (button) => {
    const productArea = button.closest('.product-card__info, product-card, .product-card, .card-wrapper, product-info, .product__info-container') || document;
    const title = productArea.querySelector('.product-card__title a[href*="/products/"]')
      || productArea.querySelector('[data-product-title]')
      || productArea.querySelector('h1')
      || productArea.querySelector('a[href*="/products/"]');
    const image = productArea.querySelector('img[alt]');
    return (title?.textContent || title?.getAttribute('data-product-title') || image?.getAttribute('alt') || '')
      .replace(/\s*-\s*Made to Measure.*$/i, '')
      .replace(/\s+/g, ' ')
      .trim();
  };

  const everyBlindRememberSelectedSample = (button) => {
    const sampleName = everyBlindGetProductName(button);
    const sampleId = button.closest('form')?.querySelector('input[name="id"]')?.value;
    if (!sampleName || !sampleId) return;

    const savedNames = everyBlindReadSampleNames();
    if (savedNames[sampleId] === sampleName) return;
    savedNames[sampleId] = sampleName;
    everyBlindWriteSampleNames(savedNames);
  };

  const everyBlindSyncSampleNames = () => {
    const savedNames = everyBlindReadSampleNames();
    let savedNamesChanged = false;
    const pageProducts = [...document.querySelectorAll('.product-samples-button, [product-samples-button]')]
      .map((button) => ({
        id: button.closest('form')?.querySelector('input[name="id"]')?.value,
        name: everyBlindGetProductName(button),
      }))
      .filter((product) => product.id && product.name);
    const pageImages = [...document.querySelectorAll('img[alt]')]
      .map((image) => ({
        alt: image.getAttribute('alt')?.trim(),
        key: everyBlindNormaliseImageName(image.currentSrc || image.src),
      }))
      .filter((image) => image.alt && image.key);

    document.querySelectorAll('.product-samples-item').forEach((item) => {
      const inner = item.querySelector('.product-samples-item__inner');
      const sampleId = item.querySelector('[data-sample-id]')?.getAttribute('data-sample-id');
      const sampleImage = item.querySelector('.product-samples-item__image');
      const imageUrl = sampleImage?.style.backgroundImage.match(/url\(["']?([^"')]+)/)?.[1] || '';
      const imageKey = everyBlindNormaliseImageName(imageUrl);
      const matchingImages = pageImages.filter((image) => image.key === imageKey);
      const matchingImage = matchingImages.find((image) => /-\s*Made to Measure/i.test(image.alt)) || matchingImages[0];
      const matchedName = matchingImage?.alt
        ?.replace(/\s*-\s*Made to Measure.*$/i, '')
        .trim();
      const matchedProductName = pageProducts.find((product) => product.id === sampleId)?.name;
      const sampleName = matchedProductName || matchedName || savedNames[sampleId] || everyBlindFallbackSampleName(imageUrl);

      if (sampleId && (matchedProductName || matchedName) && savedNames[sampleId] !== sampleName) {
        savedNames[sampleId] = sampleName;
        savedNamesChanged = true;
      }

      if (inner && inner.dataset.ebSampleName !== sampleName) {
        inner.dataset.ebSampleName = sampleName;
      }
    });

    if (savedNamesChanged) everyBlindWriteSampleNames(savedNames);
  };

  let everyBlindSampleNamesFrame;

  const everyBlindQueueSampleNames = () => {
    if (everyBlindSampleNamesFrame) return;
    everyBlindSampleNamesFrame = window.requestAnimationFrame(() => {
      everyBlindSampleNamesFrame = null;
      everyBlindSyncSampleNames();
    });
  };

  const everyBlindStartSampleNames = () => {
    everyBlindSyncSampleNames();
    new MutationObserver(everyBlindQueueSampleNames).observe(document.body, {
      childList: true,
      subtree: true,
    });
  };

  const everyBlindSyncStickyCartOffset = () => {
    const previewBar = document.querySelector('#PBarNextFrameWrapper');
    const previewBarRect = previewBar?.getBoundingClientRect();
    const previewBarHeight = previewBarRect && previewBarRect.bottom >= window.innerHeight - 8
      ? previewBarRect.height
      : 0;

    document.documentElement.style.setProperty('--eb-preview-bar-offset', `${Math.ceil(previewBarHeight)}px`);

    if (window.innerWidth > 749) {
      document.documentElement.style.removeProperty('--eb-sticky-cart-offset');
      return;
    }

    const stickyCartHeight = [...document.querySelectorAll('body *')]
      .filter((element) => !element.closest('.product-samples-widget'))
      .map((element) => {
        const styles = window.getComputedStyle(element);
        const rect = element.getBoundingClientRect();
        const label = element.textContent?.trim() || '';
        const isBottomControl = rect.bottom >= window.innerHeight - 8 && rect.top < window.innerHeight;
        const isCartControl = /add to cart|add to basket|choose options/i.test(label);
        const isPinned = styles.position === 'fixed' || styles.position === 'sticky';
        return isPinned && isBottomControl && isCartControl && rect.height <= 180 ? rect.height : 0;
      })
      .reduce((largest, height) => Math.max(largest, height), 0);

    document.documentElement.style.setProperty('--eb-sticky-cart-offset', `${Math.ceil(Math.max(stickyCartHeight, previewBarHeight))}px`);
  };

  document.addEventListener('click', (event) => {
    const sampleButton = event.target.closest('.product-samples-button, [product-samples-button]');
    if (!sampleButton) return;
    everyBlindRememberSelectedSample(sampleButton);
    window.requestAnimationFrame(everyBlindQueueSampleNames);
    window.setTimeout(everyBlindQueueSampleNames, 250);
    window.setTimeout(everyBlindQueueSampleNames, 750);
  }, true);

  document.addEventListener('click', (event) => {
    const anySamplesTrigger = event.target.closest('.product-samples-widget__trigger, [data-everyblind-sample-trigger]');
    if (!anySamplesTrigger) return;
    everyBlindSyncSampleNames();
    window.requestAnimationFrame(everyBlindSyncSampleNames);
    window.setTimeout(everyBlindSyncSampleNames, 250);
    window.setTimeout(everyBlindSyncSampleNames, 750);
  });

  everyBlindSyncStickyCartOffset();
  window.addEventListener('resize', everyBlindSyncStickyCartOffset, { passive: true });
  window.addEventListener('scroll', everyBlindSyncStickyCartOffset, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', everyBlindStartSampleNames, { once: true });
  } else {
    everyBlindStartSampleNames();
  }
  } catch(e) { console.error(e); }
})();

})();
